var map = {
	"./en/cart": [
		99012,
		9012
	],
	"./en/cart.json": [
		99012,
		9012
	],
	"./en/checkout": [
		64811,
		4811
	],
	"./en/checkout.json": [
		64811,
		4811
	],
	"./en/collection": [
		49421,
		9421
	],
	"./en/collection.json": [
		49421,
		9421
	],
	"./en/common": [
		40464,
		464
	],
	"./en/common.json": [
		40464,
		464
	],
	"./en/contact": [
		25415,
		5415
	],
	"./en/contact.json": [
		25415,
		5415
	],
	"./en/faq": [
		32113,
		4387
	],
	"./en/faq.json": [
		32113,
		4387
	],
	"./en/footer": [
		65428,
		5428
	],
	"./en/footer.json": [
		65428,
		5428
	],
	"./en/home": [
		12482,
		2482
	],
	"./en/home.json": [
		12482,
		2482
	],
	"./en/landing": [
		39942,
		9942
	],
	"./en/landing.json": [
		39942,
		9942
	],
	"./en/login": [
		16318,
		6318
	],
	"./en/login.json": [
		16318,
		6318
	],
	"./en/menu": [
		31675,
		1675
	],
	"./en/menu.json": [
		31675,
		1675
	],
	"./en/nft": [
		27289,
		7289
	],
	"./en/nft.json": [
		27289,
		7289
	],
	"./en/nftcollection": [
		7067,
		7067
	],
	"./en/nftcollection.json": [
		7067,
		7067
	],
	"./en/order": [
		80586,
		586
	],
	"./en/order.json": [
		80586,
		586
	],
	"./en/orders": [
		5726,
		5726
	],
	"./en/orders.json": [
		5726,
		5726
	],
	"./en/privacy": [
		2297,
		2297
	],
	"./en/privacy.json": [
		2297,
		2297
	],
	"./en/product": [
		24693,
		4693
	],
	"./en/product.json": [
		24693,
		4693
	],
	"./en/productcard": [
		86264,
		6264
	],
	"./en/productcard.json": [
		86264,
		6264
	],
	"./en/terms": [
		4977,
		4977
	],
	"./en/terms.json": [
		4977,
		4977
	],
	"./en/vipPopin": [
		45047,
		5047
	],
	"./en/vipPopin.json": [
		45047,
		5047
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;